module.exports = __webpack_public_path__ + "img/info-circle.4fd7cd23.svg";